import { motion, useMotionValue, useReducedMotion, useSpring } from "framer-motion";
import type { MouseEvent, PropsWithChildren } from "react";

export function Magnet({ children, className }: PropsWithChildren<{ className?: string }>) {
  const reduceMotion = useReducedMotion();
  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);
  const x = useSpring(rawX, { stiffness: 170, damping: 18, mass: 0.45 });
  const y = useSpring(rawY, { stiffness: 170, damping: 18, mass: 0.45 });

  function move(event: MouseEvent<HTMLDivElement>) {
    if (reduceMotion) return;
    const bounds = event.currentTarget.getBoundingClientRect();
    rawX.set((event.clientX - bounds.left - bounds.width / 2) * 0.11);
    rawY.set((event.clientY - bounds.top - bounds.height / 2) * 0.11);
  }

  function reset() {
    rawX.set(0);
    rawY.set(0);
  }

  return (
    <motion.div className={className} style={{ x, y }} onMouseMove={move} onMouseLeave={reset}>
      {children}
    </motion.div>
  );
}
